var navLinks = document.querySelectorAll('.photo-nav__link');

var activate = function(e) {
  if (e) {
    e.preventDefault();
  }
  var url = this.getAttribute('href');
  this.parentNode.parentNode.previousElementSibling.innerHTML = '<img class="photo-nav__current__image" src="' + url + '">';
};

for (var i = 0; i < navLinks.length; i +=1) {
  navLinks[i].addEventListener('click', activate);
}

if (navLinks.length) {
  activate.call(navLinks[0]);
}
